// E&R Eğitim Programları - 2026 Kataloğu
// Kategori ID'leri korunmuştur (yonetim-liderlik, satis, simulasyonlar,
// kisisel-gelisim, calistay, online-egitim) — mevcut navigasyon/URL'leri kırmamak için.

export const programDetails = {
  "yonetim-liderlik": {
    id: "yonetim-liderlik",
    title: "Liderlik ve Yönetim Akademileri",
    description: "Yönetsel becerileri yüksek, güven veren liderler yetiştiriyoruz.",
    programs: [
      {
        name: "Yeni Nesil Yönetici: İş, İnsan ve Performans Yönetimi",
        modules: [],
        objectives: [
          "Yönetime dair kavram ve konularda ortak bir bakış açısı oluştururlar; bir yönetici olarak kendilerinden beklenen yönetsel tavrı benimsemek ve yönettikleri ekiplere benimsetmek üzere ihtiyaç duydukları farkındalığı ve araçları edinirler.",
          "Kendilerinden başlamak üzere insanı tanır, bireyler arasındaki farklılıkların ve bireysel performansın kaynağını anlar ve en iyi sonucu üretmek üzere takım üyelerine özel stratejiler geliştirirler.",
          "Program öncesinde ve esnasında kendilerine tutulan aynalar sayesinde kişisel özelliklerini anlar, güçlü alanlarını fark ederek bu alanları kurumları ve kendileri için kullanır; gelişim alanları konusunda bilgi edinerek bu alanlarda gelişmek üzere çalışırlar.",
          "Takım dinamiklerini ve süreçlerini öğrenerek, lider olarak kendilerine düşen rolü belirlerler."
        ]
      },
      {
        name: "Mavi Yakada Liderlik ve Saha Yönetimi",
        modules: [],
        objectives: [
          "İlk kademe yöneticilerin yönetim becerilerini geliştirerek profesyonel iş yaşamlarında yürüttükleri işlerini ve ekiplerini daha etkin bir biçimde yönetebilme yetkinliklerini artırmayı amaçlar.",
          "Etkinlik tabanlı bilgi paylaşımı, iş simülasyonları ve birebir koçluk uygulamaları ile kurgulanmıştır.",
          "Her faz içinde yapılan testler ile alınan bilginin ölçümlenmesi, her faz sonrası verilen ödevler ile eğitimde elde edilen deneyimin iş hayatına aktarılmasını hedefler."
        ]
      },
      {
        name: "Anlam Mimarı",
        subtitle: "Yapay Zekâ Çağında İnsan Odaklı Liderlik",
        modules: [],
        objectives: [
          "Katılımcılar, yapay zekânın karar süreçlerindeki güçlü ve gelişime açık yönlerini doğru analiz edebilen, dijital dünyanın yarattığı duygusal ve yönetsel baskılar karşısında kendisi ve ekibi için dayanıklılık geliştirebilecektir.",
          "Verimlilik odağı içinde insanı merkeze alan ve liderlikte vicdan ile etik değerleri dijital gerçeklikle dengeli biçimde uyumlandırabilen bütüncül bir yönetim anlayışı kazanacaklardır."
        ]
      },
      {
        name: "Yeni Nesil Yöneticilik: Ekip, Karar ve Sorumluluk",
        modules: [],
        objectives: [
          "Öncelikle Yönetim ile Liderlik arasındaki farkları kurumu için tanımlayacaklardır.",
          "Birlikte çalıştığı insanların gelişimi için hedef belirlemek, motivasyon, koçluk, mentorluk ve delegasyon gibi enstrümanlar ile kişinin farklılıklarına özen göstererek Liderlik hedeflerine kolaylıkla ulaşacaklardır.",
          "Bu program bilgi aktarımından ziyade bir deneyimleme programıdır."
        ]
      },
      {
        name: "Liderler İçin Koçluk ve Gelişim Liderliği",
        modules: [],
        objectives: [
          "Koçluk ve mentorluk bir yöneticinin ekibini geliştirebilmesi için en güçlü enstrümandır.",
          "Birlikte çalıştığı insanların hem performans koçluğunu hem de gelişim mentorluğunu kişisel farklılıklarına özen göstererek yapan liderler, gelişime açık hale getirilen bir ekiple şirket hedeflerine kolaylıkla ulaşacaklardır."
        ]
      },
      {
        name: "Stratejik Düşünme ve Sonuç Odaklılık",
        modules: [],
        objectives: [
          "Üstün başarı sergilemiş kişilere ve organizasyonlara bakıldığında, bu kişileri farklı kılan özelliğin hedef belirleme konusundaki başarıları olduğu göze çarpmaktadır. Onlar; gelişigüzel belirlenmiş ve kolayca unutulan hedefler yerine, gelecek için kendilerini zorlayan, motive eden ve yönlendiren imgelerle yola çıkarlar.",
          "Kaynaklarımızın kısıtlı olduğu düşünüldüğünde çıkış noktalarından biri doğru noktaya bütün gücümüzle yüklenebilmektir.",
          "Bu eğitimde katılımcıların 'Sonuç Odaklı Stratejik Düşünme'nin önemini kavramaları ve bunu gerçekleştirmek için gerekli bilgi ve beceriye uygulayarak ulaşmaları amaçlanmaktadır."
        ]
      },
      {
        name: "Kriz ve Belirsizlikte Karar Alma",
        modules: [],
        objectives: [
          "Şirket çalışanlarının kriz ve belirsizlik dönemlerinde kuracakları iletişim konularında bilgilendirilmesi.",
          "Önceden öngörülemeyen ve beklenmedik durumlara karşı kurum yöneticilerine hazırlıklı ve deneyimli bir ekip oluşturma metodu kazandırılması.",
          "Programda hem tüm süreci tanımlamak için kült bir kriz hem de sektöre uygun kriz senaryoları kullanılarak katılımcıların kriz durumunda hem aksiyon planı çıkarmaları hem de duyguları kontrol etmeleri deneyimletilmektedir."
        ]
      },
      {
        name: "Analitik Problem Çözme ve Karar Yönetimi",
        modules: [],
        objectives: [
          "Karşılaşılan problemleri doğru şekilde ve tam zamanında çözebilen, doğru zamanda doğru kararlar alıp uygulayan şirketler rakiplerinden en az bir kademe daha ileriye gitmektedir.",
          "E&R Analitik Problem Çözme ve Karar Yönetimi eğitiminin amacı; profesyonel iş yaşamında problem çözme becerilerimizi geliştirerek daha doğru ve etkin karar verebilme yetkinliğini artırmaktır."
        ]
      },
      {
        name: "Liderler İçin Stratejik İnsan Akademisi",
        modules: [],
        objectives: [
          "Bu atölye serisinin amacı, kurumsal organizasyonların yöneticilerine ve liderlerine kurumun en değerli varlığı olan çalışanlarını yönetmek ve geliştirmekle ilgili becerileri kazandırmaktır.",
          "Katılımcılara yüksek çalışan bağlılığı, çatışma yönetimi, etkili yetenek yönetimi, hukuki bilgiler, daha iyi bir iletişim, gelişmiş karar verme mekanizmaları, maliyet tasarrufu yapma, değişim süreçlerini daha etkin yönetme ve stratejik uyumlaştırma konularında bilgi ve deneyim kazandırmayı hedefler.",
          "Yöneticilerin ve liderlerin İnsan Kaynakları süreçlerini gündelik süreçlerinin içinde kullanarak etkin ve verimli bir şekilde liderlik yapabilmelerini sağlamayı amaçlar."
        ]
      }
    ]
  },

  "satis": {
    id: "satis",
    title: "Satış ve Müşteri Deneyimi Programları",
    description: "Satış bir şirketin oksijenidir. Nefes almak kadar gereklidir.",
    programs: [
      {
        name: "Satışta Güven Kurma ve Karar Sürecini Yönetme",
        modules: [],
        objectives: [
          "Satış ekiplerinin bir gelişim programı ile yetiştirilmelerini sağlamak.",
          "Programların 1 aylık aralarla alınması önerilmektedir; katılımcılar bu aralarda edinimlerini sahada kullanma imkânını bulabilecek ve devamında eğitmen ile deneyimlerini paylaşabilecektir.",
          "Program kendi içinde bir bütünlüğe sahip olup, tanımları gereği basit görünmekle birlikte satış ekiplerinin sahadaki etkinliğini ciddi anlamda artıracaktır."
        ]
      },
      {
        name: "İkna Temelli Profesyonel Satış Teknikleri",
        subtitle: "Satış Bir İkna Eylemidir",
        modules: [],
        objectives: [
          "Kurumların satış ekiplerinin, her gün farklı yapıdaki müşterilerine ürün ya da hizmet satışı yaparken motivasyonlarını kaybetmeden ve etkin bir şekilde çalışmalarını sağlayacak yöntemler ve taktikler konusunda deneyim kazanmalarını sağlamak.",
          "Bu eğitim sayesinde satış ekipleri, müşteri tiplerini daha rahat tanımlayarak onlara uygun satış yöntemlerini kullanabilecek ve satış performanslarını artırabilmek için ipuçlarına sahip olacaklardır."
        ]
      },
      {
        name: "AI Destekli Yeni Nesil Müşteri Kazanımı",
        modules: [],
        objectives: [
          "Yeni müşteri kazanımı konusundaki geleneksel yöntemlerin yanı sıra sosyal medya kullanımı ile ilgili yetkinliklerini geliştirmek.",
          "Bu temas gelişimi ile satışını desteklemek ve potansiyellerini değerlendirmek hedeflenmektedir.",
          "Yeni müşteri hedeflemesinden randevuya, randevudan değer sunumuna, müşteriyi değerlendirmeye ve takip sistemine kadar tüm süreci katılımcılara yaşatmak."
        ]
      },
      {
        name: "Değer Merkezli Satış Dönüşümü",
        modules: [],
        objectives: [
          "Bu program sayesinde satış ekibi; satış süreçlerini değer üzerine inşa edecek, değere uygun müşteri segmentasyonunu yapabilecek ve onlara en uygun değer satış yöntemlerini kullanarak satın almalarını sağlayabilecektir."
        ]
      },
      {
        name: "Gerçek Senaryolarla Satış Deneyim Atölyesi",
        modules: [],
        objectives: [
          "E&R Satış Atölyesi eğitim programı, katılımcılara daha proaktif davranma ve çözüm satışı tarzını kazandırmak için düzenlenmiş bir günlük bir çalıştaydır.",
          "Bu programla katılımcılara 'gerçek hayat' müşteri senaryoları içerisinde, sahip oldukları deneyim ve yetkinliklerini yeni yetkinlikler ve yöntemlerle beraber uygulama imkânının verilmesi amaçlanmaktadır."
        ]
      },
      {
        name: "Yüksek Performanslı Satış Takımı Yönetimi",
        modules: [],
        objectives: [
          "Satış ekiplerini yöneten liderler, iş hedeflerine ulaşmada izleyecekleri saha koçluğu ve Liderlik süreçlerini içselleştirerek gelişim alanları konusunda farkındalık kazanacaklardır.",
          "Bu programın amacı kişileri bölge yönetimine ve/veya kilit müşteri yönetimine de hazırlamaktır."
        ]
      },
      {
        name: "Satış Müzakerelerinde Güven, Etki ve Sonuç Alma",
        modules: [],
        objectives: [
          "Teorik altyapı üzerine bina edilmiş yoğun uygulamalar ile farklı müzakere ve ikna becerilerini katılımcılara deneyimletmek.",
          "Katılımcıların müzakere becerilerini iş hayatında yüksek verimlilikle kullanabilmelerini sağlamak."
        ]
      }
    ]
  },

  "simulasyonlar": {
    id: "simulasyonlar",
    title: "Deneyim Atölyeleri — Simülasyonlar",
    description: "Deneyimleyerek öğrenilenler unutulmazdır.",
    programs: [
      {
        name: "Yüksek Performanslı Takım Deneyimi Simülasyonu",
        subtitle: "Acil Serviste Bir Cuma Gecesi",
        modules: [],
        objectives: [
          "Her masada 4-5 kişinin oynadığı 'Acil Serviste Bir Cuma Gecesi' simülasyonu katılımcılara aşağıdaki öğreti noktalarını sunar.",
          "Verilen tekil kararların sistemin bütününe ve ana hedefe etkisi.",
          "Birimler arası iletişimin etkinliği yoluyla yardımlaşma ile ana hedefe ulaşma konusunda karar verme ve hareket etme yeterliliği.",
          "İnisiyatif almaya ve inovasyona açık olmanın önemi.",
          "Doğru kararların ancak zamanında ve veriye dayalı olarak alınabileceği gerçeği."
        ]
      },
      {
        name: "Fikirden Sonuca İnovasyon Simülasyonu",
        subtitle: "Hayalden Gerçeğe",
        modules: [],
        objectives: [
          "Günümüz iş dünyasında karşılaştığımız problemlerin en büyüklerinden biri; işi gerçekleştirirken ortaya çıkan problem ve/veya fırsatları belirleyememek, belirlesek bile çözememektir. Bu problemler bizi sürekli meşgul ederken hem enerjimizden hem de konsantrasyonumuzdan çalar.",
          "Bu simülasyonda amaç; gerçek dünyada yaşadığımız bir problemi alıp bundan işe yarar bir fikir ve bu fikirden işe dönüşen bir yol haritası çıkarmaktır."
        ]
      },
      {
        name: "Çevik Süreç ve Operasyon Simülasyonu",
        subtitle: "Etkin Süreç",
        modules: [],
        objectives: [
          "E&R Çevik Süreç ve Operasyon Simülasyonu programı; size kendi tecrübelerinizden faydalanarak, bir şirket deneyimi ortamını nasıl tasarımlayacağınız bilgisini ve organizasyondaki değişimi hızlı bir şekilde yapabilmeyi deneyimleme imkânı vermeyi amaçlar."
        ]
      },
      {
        name: "Stratejik Kaynak Yönetimi Simülasyonu",
        subtitle: "Kısıtlı Kaynaklar",
        modules: [],
        objectives: [
          "Günümüzün yoğun bilgi akışı içerisinde üzerimize yağan data denizinden kullanıma uygun bilginin seçilip en uygun çözüme bir takım hâlinde ulaşmaları ve sonucunda müşteriye bir teklif ile sunma deneyimini yaşamasını sağlamak."
        ]
      },
      {
        name: "Sürdürülebilir İş Geliştirme Simülasyonu",
        subtitle: "İş Geliştirme",
        modules: [],
        objectives: [
          "İş süreçleri kullanarak verimlilik ve performansa odaklanan etkinlik tabanlı bir öğrenme deneyimidir.",
          "Odaklandığı konular: Süreç İyileştirme; Kaliteli ve Zamanında Teslimat; Kesintisiz Akış; İş Yüklerinin Dengelenmesi; Bilgi Akışı."
        ]
      },
      {
        name: "B2B Çözüm Satışı Deneyim Simülasyonu",
        modules: [],
        objectives: [
          "E&R B2B Çözüm Satışı simülasyon programı, katılımcılara daha proaktif satış tarzını kazandırmak için düzenlenmiş bir günlük bir simülasyondur.",
          "Katılımcılara 'gerçek hayat' müşteri senaryoları içerisinde, sahip oldukları deneyim ile yetkinliklerini yeni yetkinlikler ve yöntemlerle beraber uygulamalarına imkân verilmektedir.",
          "Simülasyon, aynı zamanda yönetim takımınıza katılımcıları simülasyonun gerçek hayat kurgusu içerisinde gözlemleme ve değerlendirme şansı sunmaktadır."
        ]
      },
      {
        name: "Kurumsal Dönüşüm Yolculuğu Simülasyonu",
        modules: [],
        objectives: [
          "İçinde yer aldıkları kurumların geçmişten günümüze geçirdiği yolculuktan yola çıkarak gelecekte karşılaşabilecekleri zorlukları tanımlamayı ve bunların çözümü için yöntemler geliştirmelerini amaçlar.",
          "Bu simülasyon, bilgi aktarımından ziyade tecrübe paylaşımı ile her aşamada yaşayarak öğrenme prensiplerinin deneyimlenmesi için oluşturulmuştur."
        ]
      },
      {
        name: "Sınırları Yıkan İletişim Simülasyonu",
        modules: [],
        objectives: [
          "Geri besleme, bir kişinin yaşadığı bir durum karşısında duygusunu, ihtiyacını ve fikirlerini ifade etmek amacıyla kullandığı yöntemdir. Geri beslemenin temelinde 2 farklı perspektif vardır: Benim ne gördüğüm/algıladığım, senin ne gördüğün/algıladığın.",
          "Bu simülasyonda amaç; geri beslemenin teorik yöntemlerini öğrenmek ve iletişim farklılıklarına rağmen nasıl motive edici geri besleme vereceğimizi kutu oyunuyla deneyimlemektir."
        ]
      },
      {
        name: "Rezonans",
        subtitle: "Kurum Kültürünün Yeni Frekansı",
        modules: [],
        objectives: [
          "Şirket içerisindeki kişilerin; kendi ihtiyaç, istek ve bu alanda sunduğu katkıların diğer çalışanlarda bulduğu yankıyı fark etmeleri ve bu vesile ile şirket içerisindeki bütünlüğün ve dönüşümün gelişmesi amaçlanmaktadır."
        ]
      }
    ]
  },

  "kisisel-gelisim": {
    id: "kisisel-gelisim",
    title: "Organizasyonel Dönüşüm Çözümleri",
    description: "Kurum kültürünü güçlendiren, bireyi ve organizasyonu birlikte geliştiren programlar.",
    programs: [
      {
        name: "Sonuç Odaklı Toplantı Yönetimi",
        modules: [],
        objectives: [
          "Günümüzün sonuçlara şartlanmış iş ortamında, toplantı yönetimi hiç kimse için kolay değildir. Her gün, her hafta bazı toplantılara katılmamız veya yönetmemiz gerekebilir.",
          "Bu toplantıların etkili olmaması sebebiyle kaybedilen zaman ve konsantrasyonun yerine konması çoğu katılımcı için demotive edici olmaktadır.",
          "Bu eğitimde amaç; teorik altyapı üzerine bina edilmiş yoğun vaka uygulamaları ile katılımcıların toplantı yönetimi becerilerini iş hayatında yüksek verimlilikle kullanabilmelerini sağlamaktır."
        ]
      },
      {
        name: "AI Destekli Yetkinlik Bazlı Etkin Mülakat Akademisi",
        modules: [],
        objectives: [
          "Gerçeği birebir yansıtan simülasyonlar üzerinden, uygulamalı olarak yürütülen eğitimde katılımcılar yetkinlik bazlı mülakatları somut olarak gerçekleştirme pratikleri yapacaklardır.",
          "Böylelikle kuruluş ve aday eşleştirmesini en etkin bir şekilde gerçekleştirerek yanlış adayları seçmenin kuruluşa getirdiği yükü ortadan kaldıracaklardır.",
          "Bu eğitim; sürecin en başından başlayarak adayların doğru seçilip değerlendirilmesini ve doğru pozisyona yerleştirilmelerini hedeflemektedir."
        ]
      },
      {
        name: "Müşteri Deneyiminde Mükemmellik",
        modules: [],
        objectives: [
          "Hızla gelişen ve değişen dünyada müşteri kazanmak, kazanılan müşteri ile sürekli ve sürdürülebilir iletişim sağlayabilmek fark yaratan unsurların başında geliyor.",
          "Bu eğitimle amaç; çağrı merkezi çalışanlarının veya müşteri ilişkileri sorumlularının, müşterileri ile kuracakları iletişim köprüsünde sağlıklı, sürdürülebilir ve kaliteli bir modeli yaşatabilmeleri olacaktır."
        ]
      },
      {
        name: "Kuşaklararası Etkin Müzakere ve İkna Becerileri",
        modules: [],
        objectives: [
          "Teorik altyapı üzerine bina edilmiş yoğun uygulamalar ile farklı kuşakların ikna edilmesi ve ortak noktada buluşması için farklı yöntemleri katılımcılara deneyimletmek.",
          "Müzakere ve ikna sürecinin temelinde iki ayrı bölüm vardır: tanımlama safhası (kişilerin konu hakkındaki öncelikleri ve bakış açıları) ve uygulama safhası.",
          "X, Y, Z ve Alfa kuşağının zorlukları özellikle eski kuşak ile bakış açılarının uyumsuzluğudur."
        ]
      },
      {
        name: "Etki Yaratan İletişim Becerileri",
        modules: [],
        objectives: [
          "Her alanda çalışanların mutlak ihtiyaç duyduğu yetkinliklerin başında sosyal stilleri bilmek, farklı tarzlara göre iletişim fonksiyonlarını geliştirmek, aktif dinleme, etkin beden dili kullanımı ile fark yaratabilmek gelmektedir.",
          "Bu eğitimin temel amacı; başarılı ve devam eden profesyonel deneyimleri yaşamanın en önemli kriteri olan etkin iletişim ve sosyal davranış stilleri hakkında bilgi sahibi olmaktır."
        ]
      },
      {
        name: "İş Hayatında Enerji, Zaman ve Stres Yönetimi",
        modules: [],
        objectives: [
          "Modern yönetim düşüncesinde 'Zaman' bir kaynak ve önemli bir üretim faktörü olarak ele alınmakta; bu kaynağın yatırımlar içinde temel bir paya sahip olduğu kabul edilmektedir.",
          "Zamanı etkili ve verimli bir şekilde kullanabilmek için onun iyi yönetilmesi şarttır.",
          "Sorun zamanı yönetmede değil, kişinin kendisini zaman içinde yönetebilmesindedir. Önemli olan ne kadar zamanın olduğu değil, sahip olunan zaman içinde neler yapılabileceğidir."
        ]
      },
      {
        name: "Zor Müşteri ve Durumlarla Başa Çıkma",
        modules: [],
        objectives: [
          "İnsanlar arası iletişimi oluşturan bilgi, düşünce ve duygu paylaşımı sırasında ortaya çıkabilecek iletişim zorlukları ile başa çıkma yöntemleri hakkında bilgi sahibi olmak.",
          "Müşteri tipleri ile 'zor' olarak tanımlanan ve iletişim kurmakta güçlük çeken müşteri tiplerini tanımlamak.",
          "İnsanı değiştirmek ile davranışını değiştirmek arasındaki tutum farklarını belirlemek ve uygulamalarla tecrübe kazanmak.",
          "Markanın yarattığı algıyı destekleyen bir çalışan profili oluştururken samimi, proaktif, çözümcü bir karakter sergilemenin ve bilen kişi olmanın inceliklerini algılamak ve yönetmek."
        ]
      }
    ]
  },

  "calistay": {
    id: "calistay",
    title: "Çalıştaylar",
    description: "Kısa süreli, yoğun ve uygulamalı öğrenme deneyimleri.",
    programs: [
      {
        name: "Hakuna Matata Çalıştayı",
        modules: [],
        objectives: [
          "Katılımcıların, sorumluluklarını aksatmadan kayıtsızlık sanatıyla dengeli bir yaşamı benimseyerek stres ve kaygı ile başa çıkma becerileri geliştirmeleri.",
          "Zamanı etkin yönetme yöntemlerini iş süreçleri ile hayatlarına entegre edebilmeleri amaçlanmaktadır."
        ]
      },
      {
        name: "İş Hayatında Algı ve Karar Oyunları Çalıştayı",
        modules: [],
        objectives: [
          "Katılımcıların, doğal benlik ile eleştirel benlik arasındaki farkı anlayarak değişim ve performansın önündeki engelleri fark etmeleri.",
          "Özgüvenlerini artırarak performanslarını geliştirmeleri hedeflenmektedir."
        ]
      },
      {
        name: "İyiden Mükemmele Çalıştayı",
        modules: [],
        objectives: [
          "Bir başarı öyküsünden yola çıkarak stratejiyi anlaması, iyi ile mükemmel arasındaki nüansları görebilmeleri.",
          "Bu yöntemleri bugün ya da gelecekte iş ve sosyal hayatına entegre edebilmesi; gelişim yolculuğunda güçlü bir fark yaratacaktır."
        ]
      },
      {
        name: "Propus Yıldızı Çalıştayı",
        modules: [],
        objectives: [
          "Katılımcıların dikkat dağıtıcılardan arınarak zihinsel keskinliğe ulaşmaları.",
          "Belirsizlikle başa çıkma yolları geliştirerek hayat amaçlarını (İkigai) olgunlaştırmaları.",
          "İçsel dünyalarını keşfederek dış dünya ile sağlıklı bir iletişim kurmaları hedeflenmektedir."
        ]
      },
      {
        name: "Takım Potansiyeli Çalıştayı",
        modules: [],
        objectives: [
          "Katılımcıların takım içi sorumluluklarından vazgeçmeden birlikte hareket etmelerini sağlayarak, sürdürülebilir bir takım kültürü oluşturmak.",
          "Ekip üyelerinin yöntemleri iş süreçlerine ve günlük hayatlarına entegre edebilmesini amaçlamak."
        ]
      },
      {
        name: "VUCA Çağında Stratejik Düşünme",
        modules: [],
        objectives: [
          "Katılımcıların, VUCA 1.0 dünyasının karmaşıklığını anlayarak, VUCA 2.0 ve BANI akışı ile süreçleri yönetebilmesi.",
          "Belirsizlikle başa çıkma yolları geliştirmesi.",
          "Liedtka modelini stratejik karar alma süreçlerine entegre edebilmesi hedeflenmektedir."
        ]
      },
      {
        name: "İnovasyon ve Fikir Geliştirme Çalıştayı",
        modules: [],
        objectives: [
          "Günümüz iş dünyasında karşılaştığımız problemlerin en büyüklerinden biri; gerek ilişkilerimizde gerekse işi gerçekleştirirken ortaya çıkan problem ve/veya fırsatları belirleyememek ve hatta çözememektir.",
          "Bu çalıştayda amaç; gerçek dünyada yaşadığımız bir problemi alıp bundan işe yarar bir fikir ve bu fikirden işe ve hatta gelire dönüşen bir yol haritası çıkarmaktır."
        ]
      }
    ]
  },

  "online-egitim": {
    id: "online-egitim",
    title: "Online Eğitimler",
    description: "Uzaktan erişilebilir, esnek ve etkileşimli online eğitim programları.",
    programs: [
      {
        name: "Yeni Nesil Yönetici: İş, İnsan ve Performans Yönetimi Online",
        modules: [],
        objectives: [
          "'Yeni Nesil Yönetici: İş, İnsan ve Performans Yönetimi' programının uzaktan eğitim formatında, etkileşimli online versiyonudur.",
          "Yönetime dair kavram ve konularda ortak bakış açısı oluşturma ve takım dinamiklerini kavrama becerilerini online ortamda kazandırır."
        ]
      },
      {
        name: "Uçtan Uca Satış Performans Yönetimi Online",
        modules: [],
        objectives: [
          "Satış ekiplerinin uçtan uca performans yönetimi süreçlerini online ortamda öğrenmesini ve uygulamasını amaçlar.",
          "Satış süreci geliştirme, etkin müşteri iletişimi ve saha takibi konularında etkileşimli içerikler sunar."
        ]
      },
      {
        name: "Değişim Sürecinde Liderlik Online",
        modules: [],
        objectives: [
          "Değişim süreçlerinde liderlik rolünü anlama ve uygulama.",
          "Online ortamda etkileşimli değişim yönetimi deneyimi."
        ]
      },
      {
        name: "Etki Yaratan İletişim Becerileri Online",
        modules: [],
        objectives: [
          "Sosyal stilleri ve farklı tarzlara göre iletişim fonksiyonlarını online ortamda geliştirmek.",
          "Aktif dinleme ve etkin beden dili farkındalığı."
        ]
      },
      {
        name: "Yoğun İş Akışında Odak, Öncelik ve Dayanıklılık Online",
        modules: [],
        objectives: [
          "Yoğun iş akışında dikkat dağıtıcıları yönetme, doğru önceliklendirme ve zihinsel dayanıklılık geliştirme becerilerini online ortamda kazandırır."
        ]
      },
      {
        name: "Stratejik Düşünme ve Sonuç Odaklılık Online",
        modules: [],
        objectives: [
          "Hedef belirleme, sonuç odaklı stratejik düşünme ve kaynakları doğru noktaya yoğunlaştırma yöntemlerini online geliştirme."
        ]
      },
      {
        name: "Kriz ve Belirsizlikte Karar Alma Online",
        modules: [],
        objectives: [
          "Kriz yönetimi ve kriz iletişimi konularında online bilgilendirme.",
          "Beklenmedik durumlara karşı hazırlıklı olma ve aksiyon planı çıkarma."
        ]
      },
      {
        name: "Yeni Nesil Yöneticilik: Ekip, Karar ve Sorumluluk Online",
        modules: [],
        objectives: [
          "Yönetim ile liderlik arasındaki farkları kavrama; motivasyon, koçluk, mentorluk ve delegasyon araçlarını online ortamda deneyimleme."
        ]
      },
      {
        name: "Kuşaklararası Etkin Müzakere ve İkna Becerileri Online",
        modules: [],
        objectives: [
          "Farklı kuşakların ikna edilmesi ve ortak noktada buluşması için farklı müzakere yöntemlerini online deneyimleme.",
          "Müzakere becerilerini iş hayatında yüksek verimlilikle kullanabilme."
        ]
      }
    ]
  }
};
